import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let TopBar = class TopBar extends Vue {
    constructor() {
        super(...arguments);
        this.opacity = 0;
        this.scrollTop = 0;
    }
    change(val) {
        console.log('======', val, this.isOpacity);
        if (!this.isOpacity) {
            this.opacity = 1;
        }
    }
    mounted() {
        console.log('-----', this.isOpacity);
        if (this.isOpacity) {
            window.addEventListener('scroll', this.scrollEvent);
        }
        else {
            this.opacity = 1;
        }
        this.shareOpt && env.shareInfo(this.shareOpt);
    }
    destroyed() {
        if (this.isOpacity) {
            window.removeEventListener('scroll', this.scrollEvent);
        }
    }
    scrollEvent() {
        this.scrollTop =
            window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
        this.scrollTop > 85
            ? (this.opacity = 1)
            : (this.opacity = this.scrollTop * 0.015);
    }
    async back() {
        let list = ['拼团规则', '更多拼团', '参团详情'];
        if (this.useRouterBack || list.indexOf(this.title) > -1) {
            this.$router.go(-1);
        }
        else {
            await env.init();
            await this.$emit('intellect-statistics', 'stay');
            await env.back();
        }
    }
    async share() {
        await env.init();
        let options = {};
        if (this.shareOpt) {
            options = this.shareOpt;
            await env.share(options);
        }
    }
};
tslib_1.__decorate([
    Prop({ default: 25 })
], TopBar.prototype, "navbarHeight", void 0);
tslib_1.__decorate([
    Prop({ default: '常青藤爸爸' })
], TopBar.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], TopBar.prototype, "isOpacity", void 0);
tslib_1.__decorate([
    Prop()
], TopBar.prototype, "shareOpt", void 0);
tslib_1.__decorate([
    Prop()
], TopBar.prototype, "listen", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], TopBar.prototype, "useRouterBack", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], TopBar.prototype, "needStatistics", void 0);
tslib_1.__decorate([
    Watch('isOpacity')
], TopBar.prototype, "change", null);
TopBar = tslib_1.__decorate([
    Component({
        components: {},
    })
], TopBar);
export default TopBar;
